import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'profile',
  'body-surface-area-measurements',
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'fitness_tracking',
  type: 'get',
  slug: [
    'bsa_measurements',
    {
      type: 'payload.query',
      queryParameter: 'user_id',
      selector: 'userId',
    },
    {
      type: 'payload.query',
      queryParameter: 'period',
      selector: 'period',
    },
    {
      type: 'payload.query',
      queryParameter: 'base_date',
      selector: 'baseDate',
    },
  ],
});
export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/profiles/patientHealthboard/body-surface-area-measurements-req.js